export default {
  donation: {}
};
